module.exports = __webpack_public_path__ + "img/GOUV_MENJE.0c692c6f.png";